import script from "./ToursOverviewMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToursOverviewMap.vue?vue&type=script&lang=ts&setup=true"

import "./ToursOverviewMap.vue?vue&type=style&index=0&id=40512807&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40512807"]])

export default __exports__